import(/* webpackMode: "eager" */ "D:\\dev\\danchudoba\\app\\global-error.tsx");
